var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BikyConfigSchedule",class:{
    'BikyConfigSchedule--dark': _vm.$vuetify.theme.dark,
  },on:{"click":function($event){_vm.menu = !_vm.menu}}},[_c('BikyConfigSkillBubble',{attrs:{"skill":_vm.skill}}),(_vm.menu)?_c('div',{staticClass:"BikyConfigSchedule__menu"},[_c('ContextListMenu',{attrs:{"items":_vm.menuItems}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }